"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var TextInput_1 = tslib_1.__importDefault(require("./TextInput"));
function PasswordInput(_a) {
    var inputProps = _a.inputProps, otherProps = tslib_1.__rest(_a, ["inputProps"]);
    return react_1.default.createElement(TextInput_1.default, tslib_1.__assign({}, otherProps, { inputProps: tslib_1.__assign(tslib_1.__assign({}, inputProps), { type: 'password' }) }));
}
exports.default = PasswordInput;
//# sourceMappingURL=PasswordInput.js.map